const CREATE_LEADER = 'dofe-bo/leader/CREATE_LEADER'
const CREATE_LEADER_SUCCESS = 'dofe-bo/leader/CREATE_LEADER_SUCCESS'
const CREATE_LEADER_FAIL = 'dofe-bo/leader/CREATE_LEADER_FAIL'

const GET_REG_INFO = 'dofe-bo/leader/GET_REG_INFO'
const GET_REG_INFO_SUCCESS = 'dofe-bo/leader/GET_REG_INFO_SUCCESS'
const GET_REG_INFO_FAIL = 'dofe-bo/leader/GET_REG_INFO_FAIL'

const initialState = {
  loading: false,
  loaded: false,
  loadingRegInfo: false,
  loadedRegInfo: false,
  levels: []
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CREATE_LEADER:
      return {
        ...state,
        loading: true
      }
    case CREATE_LEADER_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case CREATE_LEADER_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_REG_INFO:
      return {
        ...state,
        loadingRegInfo: true
      }
    case GET_REG_INFO_SUCCESS:
      return {
        ...state,
        loadingRegInfo: false,
        loadedRegInfo: true,
        orgContactRegistration: JSON.parse(action.result)
      }
    case GET_REG_INFO_FAIL:
      return {
        ...state,
        loadingRegInfo: false,
        loadedRegInfo: false,
        error: action.error
      }
    default:
      return state
  }
}

export function createLeader(data) {
  return {
    types: [CREATE_LEADER, CREATE_LEADER_SUCCESS, CREATE_LEADER_FAIL],
    promise: client => client.post('api/award-leader-registration', {
      removeToken: true,
      data
    })
  }
}

export function getRegistrationInfo(code) {
  return {
    types: [GET_REG_INFO, GET_REG_INFO_SUCCESS, GET_REG_INFO_FAIL],
    promise: client =>
      client.get(
        `api/organization-contact-registrations/using-authorization-code?authorizationCode=${code}`,
        {
          removeToken: true,
          textResponse: true
        }
      )
  }
}


